"use client";

import "swiper/css";
import "swiper/css/pagination";
import "./styles/BannerCarousel_1.css";

import { Box, Flex, IconButton, Text } from "@chakra-ui/react";
import { Swiper, SwiperSlide } from "swiper/react";

import { ImTicket } from "react-icons/im";
import { Pagination } from "swiper/modules";
import { BannerCarouselProps } from "../../../@types/Carousel";
import Image from "../../Image";

function BannerCarousel_1({ swiperConfig, bannerItems }: BannerCarouselProps) {
  if (!bannerItems) return null;
  return (
    <Swiper
      spaceBetween={50}
      slidesPerView={1}
      modules={[Pagination]}
      pagination={{
        clickable: true,

        bulletActiveClass: "banner-carousel-1__bullet-active",
        bulletClass: "banner-carousel-1__bullet",
        renderBullet: function (index, className) {
          return `<span class="${className}"></span>`;
        },
      }}
      {...swiperConfig}
    >
      {bannerItems?.map(
        (
          {
            showBannerAction,
            showBuyButton = false,
            bannerImg,
            bannerActionElem,
          },
          index,
        ) => (
          <SwiperSlide key={`banner_slide_${index}`}>
            <Box
              w="full"
              h="40rem"
              sx={{
                borderRadius: "1rem",
                overflow: "hidden",
              }}
              position="relative"
            >
              <Image
                objectFit="cover"
                w="full"
                h="full"
                objectPosition="center"
                src={bannerImg}
                alt={`banner_slide_${index}`}
              />
              {showBannerAction && (
                <Box
                  position="absolute"
                  sx={{
                    bottom: "1rem",
                    left: "1rem",
                  }}
                >
                  {showBuyButton && (
                    <Flex
                      alignItems="center"
                      gap={4}
                      background="rgba(0,0,0,0.3)"
                      borderRadius="13px"
                      px="1rem"
                      py="1rem"
                      cursor="pointer"
                      role="group"
                      color="white"
                      zIndex={500}
                    >
                      <IconButton
                        size="lg"
                        _groupHover={{
                          bg: "primary.500",
                          borderColor: "primary.500",
                        }}
                        transition="all 0.6s ease"
                        borderRadius="full"
                        variant="outline"
                        fontSize="2xl"
                        aria-label="Ticket"
                        icon={<ImTicket />}
                      />
                      <Text
                        fontSize="xl"
                        fontWeight={600}
                        textTransform="uppercase"
                      >
                        Buy Now
                      </Text>
                    </Flex>
                  )}
                  <>{bannerActionElem}</>
                </Box>
              )}
            </Box>
          </SwiperSlide>
        ),
      )}
    </Swiper>
  );
}

export default BannerCarousel_1;
